export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Sources',
      desc: 'Every spreadsheet entry is verified by community members to ensure authenticity and quality before being listed.',
    },
    {
      icon: 'ri-camera-line',
      title: 'QC Images Included',
      desc: 'Real quality control photos accompany each product listing so you know exactly what you are getting before purchase.',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Price Tracking',
      desc: 'Track price changes across sellers and categories to find the best deals at the right time.',
    },
    {
      icon: 'ri-star-line',
      title: 'Seller Ratings',
      desc: 'Transparent seller ratings help you choose reliable sources based on real community feedback and experiences.',
    },
  ];

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-block px-3 py-1 text-xs font-semibold text-primary-700 bg-primary-100 rounded-full mb-3">
            Why Trust Us
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            Why Users Trust Our pandabuyspreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-lg border border-background-200/60"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-primary-100 rounded-xl mb-4">
                <i className={`${f.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}